// frontend/src/modules/folha/pages/FolhaPagamento.js
import React, { useState, useEffect } from 'react';
import { FaPlus, FaPrint, FaFilePdf, FaCheck, FaTimes, FaEye, FaUsers } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

// ✅ ADICIONAR API_URL
const API_URL = process.env.REACT_APP_API_URL || '';

function FolhaPagamento({ usuario }) {
  const empresaId = usuario?.empresa_id || 1;
  const navigate = useNavigate();
  const [funcionarios, setFuncionarios] = useState([]);
  const [folhas, setFolhas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [mostrarForm, setMostrarForm] = useState(false);
  const [modoLote, setModoLote] = useState(false);
  const [formData, setFormData] = useState({
    funcionario_id: '',
    mes_referencia: '',
    ano_referencia: new Date().getFullYear(),
    data_pagamento: new Date().toISOString().split('T')[0]
  });
  const [loteData, setLoteData] = useState({
    mes_referencia: '',
    ano_referencia: new Date().getFullYear(),
    data_pagamento: new Date().toISOString().split('T')[0],
    funcionarios_selecionados: []
  });

  const isMobile = useMediaQuery({ maxWidth: 768 });
  const token = localStorage.getItem('token');

  // ✅ CORRIGIDO - URL com /folha
const fetchFuncionarios = async () => {
  try {
    // ✅ URL CORRETA - usar a rota que criamos no backend
    const response = await fetch(`${API_URL}/api/folha/empresa/${empresaId}/funcionarios`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Erro ao buscar funcionários');
    const data = await response.json();
    setFuncionarios(Array.isArray(data) ? data : []);
  } catch (err) {
    console.error('Erro funcionários:', err);
    setError(err.message);
  }
};

  // ✅ CORRIGIDO - URL com /folha
  const fetchFolhas = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/folha/empresa/${empresaId}/folhas`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) throw new Error('Erro ao buscar folhas');
      const data = await response.json();
      
      // ✅ Garantir array e converter valores
      const folhasFormatadas = (Array.isArray(data) ? data : []).map(folha => ({
        ...folha,
        salario_base: parseFloat(folha.salario_base) || 0,
        total_beneficios: parseFloat(folha.total_beneficios) || 0,
        total_descontos: parseFloat(folha.total_descontos) || 0,
        total_adiantamentos: parseFloat(folha.total_adiantamentos) || 0,
        valor_liquido: parseFloat(folha.valor_liquido) || 0,
        inss: parseFloat(folha.inss) || 0,
        irrf: parseFloat(folha.irrf) || 0,
        fgts: parseFloat(folha.fgts) || 0,
      }));
      
      setFolhas(folhasFormatadas);
    } catch (err) {
      console.error('Erro folhas:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFuncionarios();
    fetchFolhas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const url = modoLote 
        ? `${API_URL}/api/folha/lote`
        : `${API_URL}/api/folha/funcionarios/${formData.funcionario_id}/folha`;

      const body = modoLote ? {
        funcionarios: loteData.funcionarios_selecionados.map(id => ({
          funcionario_id: id
        })),
        mes_referencia: loteData.mes_referencia,
        ano_referencia: loteData.ano_referencia,
        data_pagamento: loteData.data_pagamento
      } : {
        mes_referencia: formData.mes_referencia,
        ano_referencia: formData.ano_referencia,
        data_pagamento: formData.data_pagamento
      };

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(body)
      });

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.error || 'Erro ao gerar folha');
      }

      setSuccess('✅ Folha gerada com sucesso!');
      setMostrarForm(false);
      setFormData({
        funcionario_id: '',
        mes_referencia: '',
        ano_referencia: new Date().getFullYear(),
        data_pagamento: new Date().toISOString().split('T')[0]
      });
      setLoteData({
        mes_referencia: '',
        ano_referencia: new Date().getFullYear(),
        data_pagamento: new Date().toISOString().split('T')[0],
        funcionarios_selecionados: []
      });
      fetchFolhas();
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value || 0);
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleDateString('pt-BR');
  };

  if (loading && folhas.length === 0) return <div style={{ textAlign: 'center', padding: '50px' }}>🔄 Carregando...</div>;

  return (
    <div style={{ padding: isMobile ? '10px' : '20px', maxWidth: '1200px', margin: '0 auto' }}>
      {/* Cabeçalho */}
      <div style={{ 
        display: 'flex', 
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: 'space-between', 
        alignItems: isMobile ? 'stretch' : 'center', 
        marginBottom: '20px',
        gap: '10px'
      }}>
        <h2 style={{ margin: 0, fontSize: isMobile ? '20px' : '28px' }}>📄 Folha de Pagamento</h2>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          <button 
            onClick={() => { setMostrarForm(!mostrarForm); setModoLote(false); }}
            style={{ 
              padding: isMobile ? '8px 16px' : '10px 20px', 
              backgroundColor: '#28a745', 
              color: 'white', 
              border: 'none', 
              borderRadius: '4px', 
              cursor: 'pointer',
              fontSize: isMobile ? '13px' : '14px',
              flex: isMobile ? '1' : '0',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              justifyContent: 'center'
            }}
          >
            <FaPlus /> Individual
          </button>
          <button 
            onClick={() => { setMostrarForm(!mostrarForm); setModoLote(true); }}
            style={{ 
              padding: isMobile ? '8px 16px' : '10px 20px', 
              backgroundColor: '#007bff', 
              color: 'white', 
              border: 'none', 
              borderRadius: '4px', 
              cursor: 'pointer',
              fontSize: isMobile ? '13px' : '14px',
              flex: isMobile ? '1' : '0',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              justifyContent: 'center'
            }}
          >
            <FaUsers /> Em Lote
          </button>
        </div>
      </div>

      {error && <div style={{ backgroundColor: '#ffebee', padding: '10px', borderRadius: '4px', color: '#c62828', marginBottom: '15px' }}>❌ {error}</div>}
      {success && <div style={{ backgroundColor: '#e8f5e9', padding: '10px', borderRadius: '4px', color: '#2e7d32', marginBottom: '15px' }}>✅ {success}</div>}

      {/* Formulário */}
      {mostrarForm && (
        <form onSubmit={handleSubmit} style={{ backgroundColor: '#f8f9fa', padding: isMobile ? '15px' : '20px', borderRadius: '8px', marginBottom: '20px' }}>
          <h3 style={{ fontSize: isMobile ? '16px' : '18px', marginTop: 0 }}>{modoLote ? '📋 Folha em Lote' : '📝 Nova Folha'}</h3>
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '15px' }}>
            
            {!modoLote && (
              <div>
                <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Funcionário *</label>
                <select 
                  value={formData.funcionario_id} 
                  onChange={(e) => setFormData({...formData, funcionario_id: e.target.value})}
                  required
                  style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px' }}
                >
                  <option value="">Selecione...</option>
                  {funcionarios.map(f => (
                    <option key={f.id} value={f.id}>{f.nome_completo}</option>
                  ))}
                </select>
              </div>
            )}

            <div>
              <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Mês Referência *</label>
              <select 
                value={modoLote ? loteData.mes_referencia : formData.mes_referencia}
                onChange={(e) => {
                  if (modoLote) setLoteData({...loteData, mes_referencia: e.target.value});
                  else setFormData({...formData, mes_referencia: e.target.value});
                }}
                required
                style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px' }}
              >
                <option value="">Selecione...</option>
                <option value="janeiro">Janeiro</option>
                <option value="fevereiro">Fevereiro</option>
                <option value="março">Março</option>
                <option value="abril">Abril</option>
                <option value="maio">Maio</option>
                <option value="junho">Junho</option>
                <option value="julho">Julho</option>
                <option value="agosto">Agosto</option>
                <option value="setembro">Setembro</option>
                <option value="outubro">Outubro</option>
                <option value="novembro">Novembro</option>
                <option value="dezembro">Dezembro</option>
              </select>
            </div>

            <div>
              <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Ano Referência *</label>
              <select 
                value={modoLote ? loteData.ano_referencia : formData.ano_referencia}
                onChange={(e) => {
                  if (modoLote) setLoteData({...loteData, ano_referencia: parseInt(e.target.value)});
                  else setFormData({...formData, ano_referencia: parseInt(e.target.value)});
                }}
                required
                style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px' }}
              >
                {[2024, 2025, 2026, 2027].map(a => (
                  <option key={a} value={a}>{a}</option>
                ))}
              </select>
            </div>

            <div>
              <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Data Pagamento *</label>
              <input 
                type="date"
                value={modoLote ? loteData.data_pagamento : formData.data_pagamento}
                onChange={(e) => {
                  if (modoLote) setLoteData({...loteData, data_pagamento: e.target.value});
                  else setFormData({...formData, data_pagamento: e.target.value});
                }}
                required
                style={{ width: '100%', padding: '8px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '4px' }}
              />
            </div>

            {modoLote && (
              <div style={{ gridColumn: '1 / -1' }}>
                <label style={{ fontSize: isMobile ? '13px' : '14px' }}>Funcionários *</label>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '5px' }}>
                  {funcionarios.map(f => (
                    <label key={f.id} style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: isMobile ? '12px' : '13px' }}>
                      <input 
                        type="checkbox"
                        checked={loteData.funcionarios_selecionados.includes(f.id)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setLoteData({...loteData, funcionarios_selecionados: [...loteData.funcionarios_selecionados, f.id]});
                          } else {
                            setLoteData({...loteData, funcionarios_selecionados: loteData.funcionarios_selecionados.filter(id => id !== f.id)});
                          }
                        }}
                      />
                      {f.nome_completo}
                    </label>
                  ))}
                </div>
              </div>
            )}
          </div>
          <button type="submit" disabled={loading} style={{ 
            marginTop: '15px', 
            padding: isMobile ? '8px 20px' : '10px 30px', 
            backgroundColor: '#007bff', 
            color: 'white', 
            border: 'none', 
            borderRadius: '4px', 
            cursor: 'pointer',
            width: isMobile ? '100%' : 'auto'
          }}>
            <FaCheck /> {loading ? 'Gerando...' : 'Gerar Folha'}
          </button>
        </form>
      )}

      {/* Lista de Folhas */}
      <div style={{ backgroundColor: 'white', padding: isMobile ? '10px' : '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', overflowX: 'auto' }}>
        <h3 style={{ fontSize: isMobile ? '16px' : '18px' }}>📋 Histórico de Folhas</h3>
        {folhas.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '30px' }}>
            <div style={{ fontSize: '48px', marginBottom: '10px' }}>📭</div>
            <p style={{ color: '#6c757d' }}>Nenhuma folha gerada</p>
          </div>
        ) : isMobile ? (
          <div>
            {folhas.map(f => (
              <div key={f.id} style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', padding: '12px', marginBottom: '10px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
                  <strong>{f.funcionario?.nome_completo || '-'}</strong>
                  <span style={{ fontWeight: 'bold', color: '#007bff' }}>{formatCurrency(f.valor_liquido)}</span>
                </div>
                <div style={{ fontSize: '12px', color: '#6c757d' }}>
                  📅 {f.mes_referencia} {f.ano_referencia} | 📆 {formatDate(f.data_pagamento)}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f8f9fa' }}>
                <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>Funcionário</th>
                <th style={{ padding: '10px', textAlign: 'left', borderBottom: '2px solid #dee2e6' }}>Mês/Ano</th>
                <th style={{ padding: '10px', textAlign: 'right', borderBottom: '2px solid #dee2e6' }}>Salário Base</th>
                <th style={{ padding: '10px', textAlign: 'right', borderBottom: '2px solid #dee2e6' }}>Líquido</th>
                <th style={{ padding: '10px', textAlign: 'center', borderBottom: '2px solid #dee2e6' }}>Pagamento</th>
                <th style={{ padding: '10px', textAlign: 'center', borderBottom: '2px solid #dee2e6' }}>Status</th>
                <th style={{ padding: '10px', textAlign: 'center', borderBottom: '2px solid #dee2e6' }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {folhas.map(f => (
                <tr key={f.id} style={{ borderBottom: '1px solid #dee2e6' }}>
                  <td style={{ padding: '10px' }}>{f.funcionario?.nome_completo || '-'}</td>
                  <td style={{ padding: '10px' }}>{f.mes_referencia} {f.ano_referencia}</td>
                  <td style={{ padding: '10px', textAlign: 'right' }}>{formatCurrency(f.salario_base)}</td>
                  <td style={{ padding: '10px', textAlign: 'right', fontWeight: 'bold' }}>{formatCurrency(f.valor_liquido)}</td>
                  <td style={{ padding: '10px', textAlign: 'center' }}>{formatDate(f.data_pagamento)}</td>
                  <td style={{ padding: '10px', textAlign: 'center' }}>
                    <span style={{
                      padding: '3px 10px',
                      borderRadius: '12px',
                      backgroundColor: f.status === 'PAGO' ? '#d4edda' : f.status === 'CANCELADO' ? '#f8d7da' : '#fff3cd',
                      color: f.status === 'PAGO' ? '#155724' : f.status === 'CANCELADO' ? '#721c24' : '#856404'
                    }}>
                      {f.status}
                    </span>
                  </td>
                  <td style={{ padding: '10px', textAlign: 'center' }}>
                    <button 
                      onClick={() => navigate(`/holerite/${f.id}`)}
                      style={{ background: 'none', border: 'none', color: '#007bff', cursor: 'pointer' }}
                      title="Ver Holerite"
                    >
                      <FaEye />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default FolhaPagamento;